<div class="user-menu" (click)="navigateToMail()">
  <i class="pi pi-envelope" pTooltip="Centro de Mensajes"></i>
</div>

<div class="user-menu" (click)="toggleUserMenu($event)">
  <i class="pi pi-user"></i>
  <span class="user-name"> {{ rolDescripcion ? rolDescripcion.toUpperCase() + ' (' + rolId + ')' : '' }} | {{ usser }}</span>
</div>

<p-menu #userMenu [popup]="true" [model]="items">
  <ng-template pTemplate="item" let-item>
    <a class="p-menuitem-link" (click)="item.command()">
      <i [class]="item.icon"></i>
      <span>{{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>